import React, { useState, useEffect } from "react";
import { Menu, Layout } from "antd";
import {
    TeamOutlined,
    SolutionOutlined,
    RadarChartOutlined,
    UserAddOutlined,
    FileProtectOutlined,
    DatabaseOutlined
} from '@ant-design/icons';
import { inject, observer } from "mobx-react";
import { useNavigate } from "react-router-dom";

import './styles.scss';

const { Sider } = Layout;


const SideNav = ({ userStore, collapsed, setCollapsed }) => {
    const user = JSON.parse(localStorage.getItem("dXNlclN0b3Jl"));
    const usermetadata = user ? user.metadata : "";

    const navigate = useNavigate()
    const [activeNavs, setActiveNavs] = useState([])
    
    // FOR DEFAULT METADATA VALUES
    const defaultpermissions = {
        hasAddClusterLeader: false,
        hasfundAllocation: false,
        hasEvents: false,
        hasOrganization: false
    };
    const defaultstring = JSON.stringify(defaultpermissions);
    const defaultmetadata = btoa(defaultstring);
    const metadata = usermetadata ? usermetadata : defaultmetadata;

    const decodedString = decodeURIComponent(escape(atob(metadata)));
    const permissions = JSON.parse(decodedString);

    useEffect (() => {
        let updatedNavs = [];

        if (userStore.userType === "SUPERADMIN") {
            updatedNavs = [...superadminItems];
        } else if(userStore.userType === "ADMIN") {
            updatedNavs = [...adminItems];
        } else if(userStore.userType === "TEAM_LEADER") {
            updatedNavs = [...teamLeaderItems];
        } else {
            updatedNavs = [...organizationItems]
        }

        setActiveNavs(updatedNavs);
    }, [userStore.userType])

    const superadminItems = [
        
        {
            key: 'users',
            icon: <UserAddOutlined />,
            label: 'User Admins',
            children: [
                {
                    key: 'admins',
                    label: 'User Admin List',
                },
                {
                    key: 'admins/add',
                    label: 'Add User Admin',
                }
            ]
        },
        {
            key: 'events',
            icon: <RadarChartOutlined />,
            label: 'Events',
            children: [
                {
                    key: 'events',
                    label: 'All Events',
                },
                {
                    key: 'events/custom',
                    label: 'Custom Events',
                }
            ]
        },
        {
            key: 'team-leaders',
            icon: <TeamOutlined />,
            label: 'District Coordinator',
            children: [
                {
                    key: 'team-leaders',
                    label: 'District Coordinator List',
                },
                {
                    key: 'team-leaders/add',
                    label: 'Add District Coordinator',
                },
                {
                    key: 'team-leaders/top-up',
                    label: 'Fund Allocation',
                } 
            ]
        },
        {
            key: 'organization',
            icon: <FileProtectOutlined />,
            label: 'Organization',
        },
        {
            key: 'voters',
            icon: <SolutionOutlined />,
            label: 'Voters',
        },
        {
            key: 'reports',
            icon: <DatabaseOutlined />,
            label: 'Reports',
            children: [
                {
                    key: 'audittrails',
                    label: 'Audit Trails',
                },
                {
                    key: 'teamleaderreports',
                    label: 'Leaders Reports',
                },
                {
                    key: 'mockelectionreports',
                    label: 'Mock Election Reports',
                }
            ]
        },
    ];

    const adminItems = [
        permissions.hasEvents === "true" ? 
        {
            key: 'events',
            icon: <RadarChartOutlined />,
            label: 'Events',
            children: [
               
                {
                    key: 'events/custom',
                    label: 'Custom Events',
                }
            ]
        }: null,
        {
            key: 'team-leaders',
            icon: <TeamOutlined />,
            label: 'District Coordinator',
            children: [
                {
                    key: 'team-leaders',
                    label: 'District Coordinator List',
                },
                permissions.hasAddClusterLeader === "true" ? 
                {
                    key: 'team-leaders/add',
                    label: 'Add District Coordinator',
                } : null,
                permissions.hasfundAllocation === "true" ? 
                {
                    key: 'team-leaders/top-up',
                    label: 'Fund Allocation',
                } : null
            ]
        },
     
        permissions.hasOrganization === "true" ? 
        {
            key: 'organization',
            icon: <FileProtectOutlined />,
            label: 'Organization',
        }: null,
        {
            key: 'voters',
            icon: <SolutionOutlined />,
            label: 'Voters',
        }
       
    ];

    const teamLeaderItems = [
        {
            key: 'events',
            icon: <RadarChartOutlined />,
            label: 'Events',
        },
        {
            key: 'organization',
            icon: <FileProtectOutlined />,
            label: 'Organization',
        },
        {
            key: 'mock-voting',
            icon: <SolutionOutlined />,
            label: 'Mock Voting',
        },
        {
            key: 'voters',
            icon: <SolutionOutlined />,
            label: 'Voters',
        },
    ];

    const organizationItems = [
        {
            key: 'organization',
            icon: <FileProtectOutlined />,
            label: 'Organization',
        }
    ];

    return (
        <Sider trigger={null} collapsible collapsed={collapsed} width={230}>
            <div className="logo">
            </div>
            <Menu
                theme="dark"
                mode="inline"
                onClick={(e) => {
                    navigate(`/${e.key}`)
                    if(window.innerWidth <= 767) {
                        setCollapsed(true)
                    }
                }}
                items={activeNavs}
            />
        </Sider>
    );
};

export default inject("userStore")(observer(SideNav));
